import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-mx-2" }
const _hoisted_4 = { class: "p-mt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)
const _hoisted_6 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "confirmation-content" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Are you sure to delete ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" ?")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Dropdown, {
              filter: true,
              style: {"width":"15rem"},
              modelValue: _ctx.selectedStore,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStore) = $event)),
              options: _ctx.storeList,
              optionLabel: "name",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadList(0)))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              class: "p-button-success",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DataTable, {
          first: _ctx.goToFirstLink,
          "onUpdate:first": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
          firstModifiers: { sync: true },
          value: _ctx.lists,
          lazy: true,
          paginator: _ctx.checkPagination,
          rows: _ctx.limit,
          totalRecords: _ctx.totalRecords,
          scrollable: true,
          onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPage($event))),
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
        }, {
          empty: _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "printer_name",
              header: "Printer Name"
            }),
            _createVNode(_component_Column, {
              field: "printer_type",
              header: "Printer Type"
            }),
            _createVNode(_component_Column, {
              field: "default_printer",
              header: "Is Default"
            }),
            _createVNode(_component_Column, {
              exportable: false,
              header: "Action"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-pencil",
                  class: "p-button-rounded p-button-primary p-mr-2",
                  onClick: ($event: any) => (_ctx.editIem(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-rounded p-button-danger",
                  onClick: ($event: any) => (_ctx.confirmChangeStatus(slotProps.data))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["first", "value", "paginator", "rows", "totalRecords"])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.dialogTitle), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Save",
            icon: "pi pi-check",
            class: "p-button-primary",
            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"]))
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", {
              for: "printerName",
              class: _normalizeClass({ 'p-error': _ctx.v$.printerName.$invalid && _ctx.submitted })
            }, "Printer Name", 2),
            _createVNode(_component_InputText, {
              id: "printerName",
              modelValue: _ctx.v$.printerName.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.printerName.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.printerName.$invalid && _ctx.submitted })
            }, null, 8, ["modelValue", "class"]),
            (
              (_ctx.v$.printerName.$invalid && _ctx.submitted) ||
              _ctx.v$.printerName.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_ctx.v$.printerName.required.$message.replace("Value", "Printer Name")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", {
              for: "printerType",
              class: _normalizeClass({ 'p-error': _ctx.v$.printerType.$invalid && _ctx.submitted })
            }, "Printer Type", 2),
            _createVNode(_component_Dropdown, {
              id: "printerType",
              modelValue: _ctx.v$.printerType.$model,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.printerType.$model) = $event)),
              options: _ctx.printerTypes,
              optionLabel: "key"
            }, null, 8, ["modelValue", "options"]),
            (
              (_ctx.v$.printerType.$invalid && _ctx.submitted) ||
              _ctx.v$.printerType.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.v$.printerType.required.$message.replace("Value", "Printer Type")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", {
              for: "defaultPrinter",
              class: _normalizeClass({ 'p-error': _ctx.v$.defaultPrinter.$invalid && _ctx.submitted })
            }, "Default Printer", 2),
            _createVNode(_component_Dropdown, {
              id: "defaultPrinter",
              modelValue: _ctx.v$.defaultPrinter.$model,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.defaultPrinter.$model) = $event)),
              options: _ctx.defaultTypes,
              optionLabel: "key"
            }, null, 8, ["modelValue", "options"]),
            (
              (_ctx.v$.defaultPrinter.$invalid && _ctx.submitted) ||
              _ctx.v$.defaultPrinter.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.defaultPrinter.required.$message.replace(
                "Value",
                "Default Printer"
              )), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.statusDialog,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.statusDialog) = $event)),
        style: { width: '450px' },
        header: "Confirm"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "No",
            icon: "pi pi-times",
            class: "p-button-success",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.statusDialog = false))
          }),
          _createVNode(_component_Button, {
            label: "Yes",
            icon: "pi pi-check",
            class: "p-button-danger",
            onClick: _ctx.changeStatus
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", null, [
              _hoisted_15,
              _createElementVNode("b", null, _toDisplayString(_ctx.state.printerName), 1),
              _hoisted_16
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}